import apiSlice from '../api/api.slice';

export interface IAnalyticsStats {
  totalPosts: number;
  totalDownloads: number;
  totalUsers: number;
}

interface StatsResponse {
  status: string;
  data: IAnalyticsStats;
}

const analyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStats: builder.query<IAnalyticsStats, void>({
      query: () => ({
        url: '/api/v1/analytics/public',
        method: 'GET',
      }),
      transformResponse: (response: StatsResponse) => response.data,
    }),
  }),
});

export const { useGetStatsQuery } = analyticsApiSlice;
